import { FormikTextField } from "../../forms/Formik"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import type { PrivateCompanyDetailsFormValues } from "../billReceiverTypes"

import { DebtorNumberField } from "./DebtorNumberField"
import { DetailsAddressFormSection } from "./DetailsAddressFormSection"
import { DetailsContactFormSection } from "./DetailsContactFormSection"

type PrivatePersonProps = Readonly<{
    isMerchantAdmin: boolean
}>

export function PrivateCompanyForm({ isMerchantAdmin }: PrivatePersonProps) {
    return (
        <>
            <DebtorNumberField isMerchantAdmin={isMerchantAdmin} />
            <LocalizedStrict id="bill-receivers-form-label-company-name" attrs={{ label: true }}>
                <FormikTextField<PrivateCompanyDetailsFormValues> name="companyName" label="Company name" fullWidth />
            </LocalizedStrict>
            <DetailsAddressFormSection />
            <DetailsContactFormSection />
        </>
    )
}
